export const QUESTIONNAIRE_SCORE_CALCULATIONS = ["percent-change"] as const;
export type QuestionnaireScoreCalculation = (typeof QUESTIONNAIRE_SCORE_CALCULATIONS)[number];

export function isQuestionnaireScoreCalculation(value: unknown): value is QuestionnaireScoreCalculation {
  return QUESTIONNAIRE_SCORE_CALCULATIONS.some((calculation) => calculation === value);
}
